var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCardMembership(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 103,
    height: 103,
    viewBox: "0 0 103 103",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M85.8335 8.58333H17.1668C12.4031 8.58333 8.5835 12.4029 8.5835 17.1667V64.375C8.5835 69.1388 12.4031 72.9583 17.1668 72.9583H34.3335V94.4167L51.5002 85.8333L68.6668 94.4167V72.9583H85.8335C90.5973 72.9583 94.4168 69.1388 94.4168 64.375V17.1667C94.4168 12.4029 90.5973 8.58333 85.8335 8.58333ZM85.8335 64.375H17.1668V55.7917H85.8335V64.375ZM85.8335 42.9167H17.1668V21.4583C17.1668 19.0979 19.0981 17.1667 21.4585 17.1667H81.5418C83.9023 17.1667 85.8335 19.0979 85.8335 21.4583V42.9167Z",
    fill: "#2F9C95"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardMembership);
export default __webpack_public_path__ + "static/media/CardMembership.8c0b0d6dcf48b2583b009ad62c633778.svg";
export { ForwardRef as ReactComponent };